import { AbstractNotificationCardModel } from '../abstract-notification-card/abstract-notification-card.model';

export class JobNotificationCardModel extends AbstractNotificationCardModel {
  public statusFailedFlag: boolean;
  public statusNothingToDoFlag: boolean;
  public statusPendingFlag: boolean;
  public statusSucceedFlag: boolean;
}
